import { MapDemo } from "component/w24/layout/MapDemo"
import { ChoiceMenu } from "component/w24/structure/ChoiceMenu"
import { Localization } from "libs/localization/localization"
import React, { useEffect, useState } from "react"
import styled from "styled-components/macro"

interface Props {
  className?: string
}

export const MapShowcase = (props: Props): JSX.Element => {
  const [selectedIndex, setSelectedIndex] = useState(0)

  const maps = [
    {
      image: "/map1.jpg",
      url: "https://app.mapheim.com/event/koiene/map",
    },
    {
      image: "/map2.jpg",
      url: "https://app.mapheim.com/event/50ed42a5-bb7d-46ef-a7bb-d63cefd342fa/map",
    },
    {
      image: "/map3.jpg",
      url: "https://app.mapheim.com/m/tydals",
    },
    {
      image: "/map4.jpg",
      url: "https://app.mapheim.com/event/namsskogan/map",
    },
  ]

  useEffect(() => {
    const img = new Image()
    img.src = maps[0].image
    const img2 = new Image()
    img2.src = maps[1].image
    const img3 = new Image()
    img3.src = maps[2].image
    const img4 = new Image()
    img4.src = maps[3].image
  }, [])

  return (
    <S_MapShowcase className={props.className}>
      <S_Center>
        <S_ChoiceMenu
          selectedIndex={selectedIndex}
          items={[
            Localization.MAP_TYPE1,
            Localization.MAP_TYPE2,
            Localization.MAP_TYPE3,
            Localization.MAP_TYPE4,
          ]}
          onSelected={index => {
            setSelectedIndex(index)
          }}
        />
      </S_Center>
      <S_MapDemo
        map={maps[selectedIndex].image}
        url={maps[selectedIndex].url}
      />
    </S_MapShowcase>
  )
}

const S_MapShowcase = styled.div``

const S_Center = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

const S_ChoiceMenu = styled(ChoiceMenu)`
  margin: 40px 0 50px 0px;

  @media only screen and (min-width: 1260px) {
    display: flex;
    justify-content: center;
  }
`

const S_MapDemo = styled(MapDemo)``
